import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { attachmentLabel } from './attachment-label.js';
/**
 * Auto-generated bilaga listing for a contract body (per ADR-0028
 * addendum 2026-05-27). Renders the contract's actual attachments as
 * "Bilaga N – {namn}", ordered by the unified number, so the body's
 * "Bilagor" section can never drift from what's actually attached —
 * no hand-typed list to keep in sync.
 *
 * `attachments` is undefined in dev-gallery blank/preview modes (no
 * contract context) — there we render the placeholder instead.
 */
export function AttachmentList({ attachments, emptyText = 'Inga bilagor bifogade.', }) {
    const ordered = [...(attachments ?? [])].sort((a, b) => (a.number ?? a.ordinal + 1) - (b.number ?? b.ordinal + 1));
    if (ordered.length === 0) {
        return (_jsx("p", { className: "m-0 text-[10px] italic text-stone-500", children: emptyText }));
    }
    return (_jsx("ul", { className: "m-0 flex list-none flex-col gap-0.5 p-0 text-[10px] leading-relaxed text-stone-700", children: ordered.map((a) => (_jsxs("li", { children: [attachmentLabel(ordered, a.id), " \u2013 ", a.displayName] }, a.id))) }));
}
//# sourceMappingURL=attachment-list.js.map